(() => {
  const fieldsetSelector = '[data-collapsible-color-options]';

  const isBeyondVisibleLimit = (input) => {
    if (!input) return false;
    return window.matchMedia('(max-width: 749px)').matches
      ? input.classList.contains('color-option--extra-mobile')
      : input.classList.contains('color-option--extra-desktop');
  };

  const setExpanded = (fieldset, expanded) => {
    const toggle = fieldset.querySelector('[data-color-options-toggle]');
    if (!toggle) return;

    fieldset.classList.toggle('is-expanded', expanded);
    toggle.setAttribute('aria-expanded', String(expanded));
    const label = toggle.querySelector('span');
    if (label) label.textContent = expanded ? toggle.dataset.collapseLabel : toggle.dataset.expandLabel;
  };

  const initialize = (root = document) => {
    root.querySelectorAll(fieldsetSelector).forEach((fieldset) => {
      if (fieldset.dataset.colorCollapseInitialized === 'true') return;
      fieldset.dataset.colorCollapseInitialized = 'true';

      const toggle = fieldset.querySelector('[data-color-options-toggle]');
      if (!toggle) return;

      toggle.addEventListener('click', () => {
        setExpanded(fieldset, toggle.getAttribute('aria-expanded') !== 'true');
      });

      if (isBeyondVisibleLimit(fieldset.querySelector('input[type="radio"]:checked'))) {
        setExpanded(fieldset, true);
      }
    });
  };

  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));

  let resizeTimer;
  window.addEventListener('resize', () => {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(() => {
      document.querySelectorAll(`${fieldsetSelector}:not(.is-expanded)`).forEach((fieldset) => {
        if (isBeyondVisibleLimit(fieldset.querySelector('input[type="radio"]:checked'))) {
          setExpanded(fieldset, true);
        }
      });
    }, 120);
  });
})();
